export default __webpack_public_path__ + "static/media/2296.29f5fdb8.png";